import Hooks from 'classes/Hooks';
import { update_query_string, create_div, clear_el } from 'js/utils';

export default class Pagination {
	constructor(selector, args = {}) {
		this.args = args;
		this.el = document.querySelector(selector);
		this.buttons_con = this.el.querySelector('.pages');
		this.showposts = parseInt(this.el.dataset.showposts);
		this.hooks = new Hooks([]);

		init_back(this);
		init_next(this);

		this.init_buttons();
	}

	init_buttons() {
		this.buttons = this.buttons_con.querySelectorAll('.nav');
		if (!this.buttons) return;

		this.current = null;
		this.page = 1;

		this.buttons.forEach((btn) => {
			btn.num = parseInt(btn.textContent);

			if (btn.classList.contains('active')) {
				this.current = btn;
				this.page = btn.num;
			}

			btn.addEventListener('click', () => this.set(btn));
		});

		this.hooks.do('buttons/init');
	}

	set(btn) {
		if (btn.classList.contains('active')) return;

		if (this.current) this.current.classList.remove('active');

		btn.classList.add('active');
		this.current = btn;
		this.page = btn.num;

		update_query_string({ pp: this.page });

		this.hooks.do('set', this.page);
	}

	update(count) {
		clear_el(this.buttons_con);

		const pages = Math.ceil(count / this.showposts);

		if (pages < 2) return this.init_buttons();

		for (let i = 1; i <= pages; i++) {
			const btn = create_div('nav', this.buttons_con, i);
			if (i === 1) {
				btn.classList.add('active');
			}
		}

		this.init_buttons();
	}
}

function init_back(pagination) {
	const btn = pagination.el.querySelector('.prev');
	if (!btn) return;

	btn.addEventListener('click', () => {
		pagination.buttons[pagination.page - 2].click();
	});

	const update = () => {
		btn.dataset.enable = pagination.page > 1;
	};

	pagination.hooks.add('set', update);
	pagination.hooks.add('buttons/init', update);
}

function init_next(pagination) {
	const btn = pagination.el.querySelector('.next');
	if (!btn) return;

	btn.addEventListener('click', () => {
		pagination.buttons[pagination.page].click();
	});

	const update = () => {
		btn.dataset.enable = pagination.page < pagination.buttons.length;
	};

	pagination.hooks.add('set', update);
	pagination.hooks.add('buttons/init', update);
}
